module.exports = __webpack_public_path__ + "static/media/Galactic Bounty Hunter.c8c148f6.jpg";